import type { ShellVariant } from './ShellVariantProvider'

type FrameInputs = {
  shellVariant: ShellVariant | null
  isMobileWidth: boolean
  disableSidebar: boolean
}

/** Which frame a page renders in. While the shell is undecided it's the classic frame, holding a loading state. */
export const chooseFrame = ({ shellVariant, isMobileWidth, disableSidebar }: FrameInputs): ShellVariant => {
  if (shellVariant !== 'appShell') return 'classic'
  // TODO(SOUR-1877, SOUR-1879): move pages without the nav, and phone widths, into the app shell.
  return isMobileWidth || disableSidebar ? 'classic' : 'appShell'
}
